import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, Plus, User, Shield } from 'lucide-react';

const Navbar = ({ user, onLogout }) => {
  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-neutral-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl font-bold" style={{ fontFamily: 'Young Serif, serif', color: '#1A4D2E' }}>
              Country Chicken Market
            </span>
          </Link>

          <div className="flex items-center space-x-4">
            {user ? (
              <>
                <Link to="/create">
                  <Button 
                    data-testid="create-listing-btn"
                    className="bg-primary hover:bg-primary/90 text-white rounded-full h-10 px-6"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Create Listing
                  </Button>
                </Link>
                
                <Link to="/my-listings">
                  <Button 
                    variant="ghost" 
                    data-testid="my-listings-btn"
                    className="rounded-full"
                  >
                    <User className="w-4 h-4 mr-2" />
                    My Listings
                  </Button>
                </Link>

                {user.role === 'admin' && (
                  <Link to="/admin">
                    <Button 
                      variant="outline" 
                      data-testid="admin-dashboard-btn"
                      className="rounded-full border-2 border-primary text-primary hover:bg-primary/5"
                    >
                      <Shield className="w-4 h-4 mr-2" />
                      Admin
                    </Button>
                  </Link>
                )}

                <Button 
                  variant="ghost" 
                  onClick={onLogout}
                  data-testid="logout-btn"
                  className="rounded-full"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </Button>

                <div className="text-sm font-medium text-neutral-600">
                  {user.name}
                </div>
              </>
            ) : (
              <Link to="/auth">
                <Button 
                  data-testid="login-btn"
                  className="bg-primary hover:bg-primary/90 text-white rounded-full h-10 px-8"
                >
                  Login / Register
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;